import { TemplateNotification } from "src/globalTypes";
import wrappedAxios from "../axiosWrapper";
import { Notifications, NotificationsSubscription } from "./types";
import {
  getAllTemplateNotifications,
  getTemplateNotificationById,
  notificationSubscription,
  registerNotifications,
  resolveNotification,
} from "./urlParsers";

export const registerNotificationsForUser = (connectionId: string) =>
  wrappedAxios<void>({
    url: registerNotifications(),
    method: "GET",
    params: {
      connectionId,
    },
  });

export const fetchAllNotificationsForUser = () =>
  wrappedAxios<Notifications>({
    url: getAllTemplateNotifications(),
    method: "GET",
  });

export const fetchTemplateNotification = (templateId: number) =>
  wrappedAxios<TemplateNotification>({
    url: getTemplateNotificationById(templateId),
    method: "GET",
  });

export const getNotificationsSubscription = () =>
  wrappedAxios<NotificationsSubscription>({
    url: notificationSubscription(),
    method: "GET",
  });

export const postNotificationSubscriptionForIds = (templateIds: number[]) =>
  wrappedAxios<void>({
    url: notificationSubscription(),
    method: "POST",
    data: [...templateIds],
  });

export const deleteNotficationSubscriptionForIds = (templateIds: number[]) =>
  wrappedAxios<void>({
    url: notificationSubscription(),
    method: "DELETE",
    data: [...templateIds],
  });

export const postSendNotificationTEST = () =>
  wrappedAxios<void>({
    url: "api/NotificationSender/SendTest",
    method: "POST",
  });

export const putResolveNotifications = (notificationIds: number[]) =>
  wrappedAxios<boolean>({
    url: resolveNotification(),
    method: "PUT",
    data: [...notificationIds],
  });
